/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S6_TitleInputs */

const en_guide_json_syntax_errors_s6_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to Debug JSON Errors`)
};

const ko_guide_json_syntax_errors_s6_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 오류 디버깅 방법`)
};

const ja_guide_json_syntax_errors_s6_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONエラーのデバッグ方法`)
};

/**
* | output |
* | --- |
* | "How to Debug JSON Errors" |
*
* @param {Guide_Json_Syntax_Errors_S6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s6_title = /** @type {((inputs?: Guide_Json_Syntax_Errors_S6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s6_title(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s6_title(inputs)
	return ja_guide_json_syntax_errors_s6_title(inputs)
});